"use client";
import React, { useCallback, useContext, useMemo } from "react";
import { CommonFormProps } from "./CommonFormInterface";
import RenderField from "../RenderField/RenderField";
import { CommonFormContext } from "../MainComponent/MainComponent";
import LazySection from "@/commonJS/LazySection";

const CommonForm = ({
  formJSON,
  globalState,
  fullGlobalState,
  setGlobalState,
  collectionState,
  path
}: CommonFormProps) => {
  const context = useContext(CommonFormContext);

  const lazyPath = useCallback((divIndex: number)=>[...path??[], `lazy-cf-fr-${divIndex}`],[path]);
  const cfPath = useCallback((divIndex: number)=>[...path??[], `cf-fr-${divIndex}`],[path]);
  const renderPath = useCallback((divIndex: number)=>[...path??[], `render-fr-${divIndex}`],[path]);
  if(formJSON?.length > 0 )
    return formJSON?.map((formChild: any, divIndex: number) => {
    return Object.hasOwn(formChild??{}, "child") ? (
      context.verifyConditions(
        formChild?.conditions ? formChild?.conditions : [],
        globalState,
        globalState,
        fullGlobalState
      ) ? (
        (context?.isClient && formChild?.lazyLoad) ? <LazySection key={[...path??[], `div-lazy-cf-fr-${divIndex}`].join("-")} id={formChild?.id} fallback={formChild?.fallback} formChild={formChild} className={formChild?.lazyLoadClassName}>
          <div
            onClick={(e: any) =>
              context.handleClick && formChild.actions
                ? context.handleClick(e, formChild, globalState)
                : () => {}
            }
            onMouseEnter={(e) => {
              const hasActions = formChild?.properties?.onMouseEnter?.actions;
              if (context.handleMouseEnter && hasActions) {
                context.handleMouseEnter(e, formChild, globalState);
              }
            }}
            onMouseLeave={(e) => {
              const hasActions = formChild?.properties?.onMouseLeave?.actions;
              if (context.handleMouseLeave && hasActions) {
                context.handleMouseLeave(e, formChild, globalState);
              }
            }}
            className={formChild?.conditionalClassNames ? context.getClassNames(formChild,globalState,fullGlobalState):formChild?.className}
            style={{
              ...formChild?.style,
              ...(formChild?.activationData ? formChild?.activeItemStyle : {}),
            }}
            id={formChild.id ?? ""}
            onLoad={(e)=>{
              context.handleClick && formChild?.onLoad
            ? context.handleClick(e, {...formChild,actions:formChild.onLoad}, globalState)
            : () => {};
            }}
          >
          <CommonForm
            key={lazyPath(divIndex).join("-")}
            path={lazyPath(divIndex)}
            formJSON={formChild.child}
            globalState={globalState}
            fullGlobalState={fullGlobalState ?? globalState}
            setGlobalState={setGlobalState}
            collectionState={collectionState}
          />
        </div>
        </LazySection> : 
        <div
          key={[...path??[], `div-cf-fr-${divIndex}`].join("-")}
          onClick={(e: any) =>
            context.handleClick && formChild.actions
              ? context.handleClick(e, formChild, globalState)
              : () => {}
          }
          onMouseEnter={(e) => {
            const hasActions = formChild?.properties?.onMouseEnter?.actions;
            if (context.handleMouseEnter && hasActions) {
              context.handleMouseEnter(e, formChild, globalState);
            }
          }}
          onMouseLeave={(e) => {
            const hasActions = formChild?.properties?.onMouseLeave?.actions;
            if (context.handleMouseLeave && hasActions) {
              context.handleMouseLeave(e, formChild, globalState);
            }
          }}
          className={formChild?.conditionalClassNames ? context.getClassNames(formChild,globalState,fullGlobalState):formChild?.className}
          style={{
            ...formChild?.style,
            ...(formChild?.activationData ? formChild?.activeItemStyle : {}),
          }}
          id={formChild.id ?? ""}
          onLoad={(e)=>{
            context.handleClick && formChild?.onLoad
          ? context.handleClick(e, {...formChild,actions:formChild.onLoad}, globalState)
          : () => {};
          }}
        >
          <CommonForm
            key={cfPath(divIndex).join("-")}
            path={cfPath(divIndex)}
            formJSON={formChild.child}
            globalState={globalState}
            fullGlobalState={fullGlobalState ?? globalState}
            setGlobalState={setGlobalState}
            collectionState={collectionState}
          />
        </div>
      ) : (
        <React.Fragment key={`empty-fr-${divIndex}`}></React.Fragment>
      )
    ) : context.verifyConditions(
        formChild?.conditions ? formChild?.conditions : [],
        globalState,
        globalState,
        fullGlobalState
      ) ? (
      <RenderField
        key={renderPath(divIndex).join("-")}
        path={renderPath(divIndex)}
        fieldValue={formChild}
        globalState={globalState}
        fullGlobalState={fullGlobalState ?? globalState}
        setGlobalState={setGlobalState}
        collectionStateOrPayload={globalState}
      />
    ) : (
      <React.Fragment key={`empty-else-fr-${divIndex}`}></React.Fragment>
    );
  });else <></>
}

export default CommonForm;
